
<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li>
              <a href="#">{{ $t("purchases") }}</a>
            </li>
            <li>-</li>
            <li>
              <a class="active" href="#">{{ $t("bills") }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <h3>{{ $t("bills") }}</h3>
            <!-- <input type="text" :placeholder="$t('owner')" v-model="owner" /> -->
            <input type="text" :placeholder="$t('supplier')" v-model="supplier" />
            <input type="text" :placeholder="$t('project')" v-model="project" />
            <input type="text" :placeholder="$t('invnum')" v-model="invnum" />
            <input type="date" :placeholder="$t('from')" v-model="datefrom" />
            <input type="date" :placeholder="$t('to')" v-model="dateto" />
            <select name="" id="" v-model="status" style="border: none;">
              <option value="%">{{ $t("all") }}</option>
              <option value="waiting">{{ $t("waiting") }}</option>
              <option value="confirmed">{{ $t("confirmed") }}</option>
              <option value="deleted">{{ $t("deleted") }}</option>
            </select>
            <button style="padding: 1%" @click="search()">
              {{ $t("search") }}
            </button>
          </div>
          <div class="head2">
            <!-- <button>
              <router-link to="/ProjectsManagement/CreateProjectsBill" class="btn-download">
                <span class="text">
                  <i class="bi bi-clipboard-plus-fill"></i>
                  {{ $t("add") }} {{ $t("invoice") }} {{ $t("purchases") }}
                </span>
              </router-link>
            </button>-->
            <button @click="exportToExcel()">Excel</button>
          </div>
        </div>
        <div class="body">
          <div>
            <table-lite
              :is-static-mode="false"
              :is-slot-mode="true"
              :has-action-column="true"
              :is-loading="table.isLoading"
              :columns="table.columns"
              :rows="table.rows"
              :total="table.totalRecordCount"
              :sortable="table.sortable"
              :page-size="pageSize"
              v-model:current-page="currentPage"
              @row-delete="rowDelete"
              @row-edite="rowEdit"
              @row-view="rowView"
              @do-search="doSearch"
            >
              <template v-slot:quick="row">
                <button class="btn btn-light view-btn" @click.prevent="rowView(row.value)">
                  <i class="bi bi-search"></i>
                </button>
               <!--  <button class="btn btn-light edit-btn" @click.prevent="rowEdit(row.value)">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button  class="btn btn-light delete-btn" @click.prevent="rowDelete(row.value)">
                  <i class="bi bi-trash"></i>
                </button> -->
              </template>
            </table-lite>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { reactive } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import TableLite from "../../../components/TableLite.vue";
//   import store from "@/store";
  import axios from "axios";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";
//   import * as XLSX from "xlsx";

  export default {
    title: "Bills",
    props: ["css"],
    components: { TableLite },
    data() {
      return {
        invnum: "",
        owner: "",
        supplier: "",
        project: "",
        datefrom: "",
        dateto: "",
        status: "%",
        pageSize: 50,
        currentPage: 1,
        // r7: JSON.parse(store.state.randp.r7),
      };
    },
    mounted() {
    //   if (this.r7.create !== true) {
    //     this.redirectTo({ val: "Home" });
    //   }
      // Initialize filters from query parameters
      const route = useRoute();
      this.owner = route.query.ownername ? String(route.query.ownername) : "";
      this.supplier = route.query.sname ? String(route.query.sname) : "";
      this.project = route.query.project ? String(route.query.project) : "";
      this.invnum =route.query.invnum ? String(route.query.invnum) : "";
      this.datefrom = route.query.datefrom ? String(route.query.datefrom) : "";
      this.dateto = route.query.dateto ? String(route.query.dateto) : "";
      this.status = route.query.status ? String(route.query.status) : "%";
      this.currentPage = route.query.page ? parseInt(route.query.page, 10) || 1 : 1;
      this.pageSize = route.query.limit ? parseInt(route.query.limit, 10) || 50 : 50;

      console.log('ddddddddddddddddddd');
      // Trigger initial search with query parameters
      this.search(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize,
        route.query.order || "id",
        route.query.sort || "desc"
      );
    },
    setup() {
      const router = useRouter();
      const route = useRoute();
      const table = reactive({
        columns: [
          {
            label: "code",
            field: "bid",
            width: "1%",
            text: "BILL-",
            sortable: true,
            isKey: true,
            headerClasses: ["bg-gold", "color-red"],
            columnClasses: ["bg-gray"],
          },
          {
            label: "dueon",
            field: "due",
            width: "15%",
            sortable: true,
          },
          {
            label: "owner",
            field: "cname",
            width: "15%",
            sortable: true,
          },
          {
            label: "supplier",
            field: "sname",
            width: "15%",
            sortable: true,
          },
          {
            label: "project",
            field: "project",
            width: "15%",
            sortable: true,
          },
          {
            label: "description",
            field: "description",
            width: "10%",
            sortable: true,
          },
          {
            label: "total",
            field: "tat",
            width: "10%",
            sortable: true,
          },
          {
            label: "invnum",
            field: "invnum",
            width: "10%",
            sortable: true,
          },
          {
            label: "status",
            field: "review",
            width: "10%",
            sortable: true,
          },
          {
            label: "option",
            field: "quick",
            width: "10%",
          },
        ],
        rows: [],
        totalRecordCount: 0,
        sortable: {
          order: "id",
          sort: "desc",
        },
        isLoading: false,
      });

      const rowDelete = async (row) => {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const del = await axios.delete(`/projects/delprojectbill/${row.bid}`);
              if (del.status === 200) {
                const indexOfObject = table.rows.findIndex((object) => {
                  return object.id === row.id;
                });
                table.rows.splice(indexOfObject, 1);
                table.totalRecordCount--;
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
              }
            } catch (error) {
              Swal.fire("Error!", "Failed to delete the bill.", "error");
              console.error("Delete error:", error);
            }
          }
        });
      };

      const rowEdit = (row) => {
        router.push({
          path: `/ProjectsManagement/UpdateProjectsBill/${row.bid}`,
          query: route.query,
        });
      };

      const rowView = (row) => {
        router.push({
          path: `/customerDashboard/project/ProjectsBillView/${row.bid}`,
          query: { ...route.query, id: row.id },
        });
      };

    //   const doSearch = async function (offset, limit, order, sort) {
    //     table.isLoading = true;
    //     try {
    //       const params = {
    //         ownername: this.owner || undefined,
    //         sname: this.supplier || undefined,
    //         project: this.project || undefined,
    //         invnum: this.invnum || undefined,
    //         datefrom: this.datefrom || undefined,
    //         dateto: this.dateto || undefined,
    //         status: this.status !== "%" ? this.status : undefined,
    //         page: Math.floor(offset / limit) + 1,
    //         limit,
    //         order,
    //         sort,
    //       };
    //       console.log("doSearch params:", params);
    //       const response = await axios.post("/projects/allbills", params);
    //       table.rows = response.data.data;
    //       table.totalRecordCount = response.data.total;
    //       table.sortable.order = order;
    //       table.sortable.sort = sort;
    //     } catch (error) {
    //       console.error("doSearch error:", error);
    //       Swal.fire("Error!", "Failed to fetch bills.", "error");
    //     } finally {
    //       table.isLoading = false;
    //     }
    //   };

      return {
        table,
        rowDelete,
        rowEdit,
        rowView,
        // doSearch,
      };
    },
    methods: {
      async search() {
        this.table.isLoading = true;
        try {
          // Update URL with filter parameters
          await this.$router.push({
            path: "/customerDashboard/project/allprojectsbills",
            query: {
              ownername: this.owner || undefined,
              sname: this.supplier || undefined,
              project: this.project || undefined,
              invnum: this.invnum || undefined,
              datefrom: this.datefrom || undefined,
              dateto: this.dateto || undefined,
              status: this.status !== "%" ? this.status : undefined,
              page: String(this.currentPage),
              limit: String(this.pageSize),
              order: this.table.sortable.order,
              sort: this.table.sortable.sort,
            },
          });

          const params = {
            ownername: this.owner || undefined,
            sname: this.supplier || undefined,
            project: this.project || undefined,
            invnum: this.invnum || undefined,
            datefrom: this.datefrom || undefined,
            dateto: this.dateto || undefined,
            status: this.status !== "%" ? this.status : undefined,
            page: this.currentPage,
            limit: this.pageSize,
            order: this.table.sortable.order,
            sort: this.table.sortable.sort,
          };
          console.log("search params:", params);
          const action = await axios.get("/owner-dashboard/allbills", {
            params:params,
          });
          if (action.status === 200) {
            this.table.rows = action.data.data;
            this.table.totalRecordCount = action.data.total;
            this.currentPage = 1;
          }
        } catch (error) {
          console.error("Search error:", error);
          Swal.fire("Error!", "Failed to fetch bills.", "error");
        } finally {
          this.table.isLoading = false;
        }
      },
      async doSearch(offset, limit, order, sort) {
      this.table.isLoading = true;
      try {
        const params = {
          ownername: this.owner || '',
          sname: this.supplier || '',
          project: this.project || '',
          invnum: this.invnum || '',
          datefrom: this.datefrom || '',
          dateto: this.dateto || '',
          status: this.status !== "%" ? this.status : '',
          page: Math.floor(offset / limit) + 1,
          limit,
          order,
          sort,
        };
        console.log("doSearch params:", params);
          const response = await axios.get("/owner-dashboard/allbills", {
            params:params,
          });
        this.table.rows = response.data.data;
        this.table.totalRecordCount = response.data.total;
        this.table.sortable.order = order;
        this.table.sortable.sort = sort;
      } catch (error) {
        console.error("doSearch error:", error);
        Swal.fire("Error!", "Failed to fetch bills.", "error");
      } finally {
        this.table.isLoading = false;
      }
    },
    //   exportToExcel() {
    //     const data = this.table.rows.map((row) => ({
    //       رقم_الفاتورة: row.bid,
    //       المالك: row.cname,
    //       المشروع: row.project,
    //       المورد: row.sname,
    //       المبلغ_قبل_الضريبة: Number(row.tbt),
    //       الضريبة: Number(row.tax),
    //       المبلغ_الاجمالى: Number(row.tat),
    //       رقم_الفاتورة_الضريبية: row.invnum,
    //       التاريخ: row.due,
    //       الحالة: row.review,
    //     }));
    //     const wb = XLSX.utils.book_new();
    //     const ws = XLSX.utils.json_to_sheet(data);
    //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    //     XLSX.writeFile(wb, `المشتريات.xlsx`);
    //   },
    async exportToExcel() {
    try {
      // Prepare query parameters
      const params = {
        ownername: this.owner || undefined,
        sname: this.supplier || undefined,
        project: this.project || undefined,
        invnum: this.invnum || undefined,
        datefrom: this.datefrom || undefined,
        dateto: this.dateto || undefined,
        status: this.status !== '%' ? this.status : undefined,
        order: this.table.sortable.order,
        sort: this.table.sortable.sort,
      };

      // Make request to backend
      const response = await axios.get('/owner-dashboard/export-bills', {
        params,
        responseType: 'blob',
      });

      // Create a blob URL and trigger download
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'المشتريات.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
      Swal.fire('Error!', 'Failed to export bills.', 'error');
    }
  },
      ...mapActions(["redirectTo"]),
    },
    watch: {
      pageSize(newSize) {
        this.$router.push({
          query: {
            ...this.$route.query,
            limit: String(newSize),
            page: "1",
          },
        });
        this.doSearch(0, newSize, this.table.sortable.order, this.table.sortable.sort);
      },
      currentPage(newPage) {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: String(newPage),
          },
        });
        this.doSearch(
          (newPage - 1) * this.pageSize,
          this.pageSize,
          this.table.sortable.order,
          this.table.sortable.sort
        );
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  .page {
    direction: v-bind("css.EN");
    padding: 0.5%;
  }

  .main {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
  }

  .body {
    padding: 1%;
  }

  .part {
    font-size: large;
    width: 99%;
    padding: 2%;
    margin: 0.5%;
    background-color: white;
    border-radius: 5px;
    color: black;
    display: flex;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }

  .part .group {
    width: 50%;
  }

  .part img {
    width: 100%;
    height: 100px;
  }

  ul {
    text-decoration: none;
    list-style-type: none;
    color: black;
  }

  .bi {
    margin: 1%;
  }

  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }

  .head1 {
    width: 60%;
  }

  .head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  .head2 {
    width: 40%;
    text-align: center;
  }

  .head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
    width: 30%;
  }

  .head2 button a {
    color: white;
  }

  .view-btn,
  .edit-btn,
  .delete-btn {
    margin: 0 5px;
  }
  </style>
